import { render, staticRenderFns } from "./headerDialog.vue?vue&type=template&id=0ca88ea6&scoped=true&"
import script from "./headerDialog.vue?vue&type=script&lang=js&"
export * from "./headerDialog.vue?vue&type=script&lang=js&"
import style0 from "./headerDialog.vue?vue&type=style&index=0&id=0ca88ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca88ea6",
  null
  
)

export default component.exports